// The route table declares these paths and the board layout matches on them, so
// they are assembled once here rather than restated as literals in both places.
export const CLIENT_ROUTE_PATH = '/client';

export const CLIENT_BOARD_ROUTE_PATH = 'jobs/:jobId';

export const CLIENT_CANDIDATE_DETAIL_ROUTE_PATH = 'candidates/:handoffId';

export const CLIENT_CANDIDATE_DETAIL_PATTERN = `${CLIENT_ROUTE_PATH}/${CLIENT_BOARD_ROUTE_PATH}/${CLIENT_CANDIDATE_DETAIL_ROUTE_PATH}`;

// The source stage a detail link was opened from. Written by the board, read by
// the detail, so it is spelled once.
export const CLIENT_STAGE_ID_PARAM = 'stageId';
